import {computed, ref} from 'vue'
import {defineStore} from 'pinia'
import {useCrud} from "@/composables/CrudAxios";
import type {configObject, personArray} from "@/types/types";
import {useRoute, useRouter} from "vue-router";

export const useConfigStore = defineStore('config', () => {
    const configObject = ref({} as configObject)
    const personArray = ref([] as personArray);
    const address = computed(() => configObject.value.store.postal + " " + configObject.value.store.city + ', ' + configObject.value.store.street)
    const route = useRoute()
    const router = useRouter();

    async function getConfigObject() {
        const {getAsync} = useCrud();
        try {
            const response = await getAsync(`/extern/table/getconfig/?store=${route.query.store}`);

            if (response.status === 403) {
                await router.push({
                    path: '/forbidden',
                    query: {
                        store: route.query.store
                    }
                });
            } else {
                configObject.value = response;
            }
        } catch (err) {
            console.error(err);
        }

        let label = 'Person'
        personArray.value = new Array(configObject.value.maxperson).fill(0).map((e, i) => {
            if (i === 0) {
                return {label: [i + 1] + ' ' + label, amount: i + 1};
            } else {
                label = 'Personen'
                return {label: [i + 1] + ' ' + label, amount: i + 1};
            }
        });
    }

    return {configObject, getConfigObject, personArray, address}
})
